import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import Swal from "sweetalert2";
import { decryptFuc } from "../../utils/decrpt";

// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("my_leads");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllCompanydata = createAsyncThunk(
  "Companys/getAllCompanydata",
  async () => {
    try {
      const response = await BaseUrl.get(`/my_Leads/company`, getAuthHeaders());
      // console.log("response.data", response.data);
      const responseData = await decryptFuc(response.data.data);
      return responseData;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const createCompanyData = createAsyncThunk(
  "Companys/createCompanyData",
  async (data) => {
    try {
      const response = await BaseUrl.post(
        `/my_Leads/company`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const getCompDocdata = createAsyncThunk(
  "companys/getCompDocdata",
  async (id) => {
    // console.log("id====>", id);
    try {
      // console.log("authtnk", getAuthHeaders())
      const response = await BaseUrl.get(
        `my_Leads/companyDocs/allDocs/${id}`,
        getAuthHeaders()
      );
      // console.log("responsedata=======>", response.data);
      const responseData = await decryptFuc(response.data.data);
      return responseData;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const CreateCompDocdata = createAsyncThunk(
  "companys/CreateCompDocdata",
  async (data) => {
    try {
      const response = await BaseUrl.post(
        `my_Leads/companyDocs`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const updateCompdata = createAsyncThunk(
  "companys/updateCompdata",
  async (data) => {
    try {
      const response = await BaseUrl.patch(
        `my_Leads/company`,
        data,
        getAuthHeaders()
      );
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const getCompanyDropdata = createAsyncThunk(
  "companys/getCompanyDropdata",
  async () => {
    try {
      const response = await BaseUrl.get(
        `/my_Leads/company/companyDropDown`,
        getAuthHeaders()
      );
      // console.log("response.data", response.data.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);

export const getSingleCompanydata = createAsyncThunk(
  "Companys/getSingleCompanydata",
  async (id) => {
    try {
      const response = await BaseUrl.get(
        `/my_Leads/company/${id}`,
        getAuthHeaders()
      );
      const responseData = await decryptFuc(response.data.data);
      // console.log("getSingleCompanydata", responseData);
      return responseData;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const getSingleCompDoc = createAsyncThunk(
  "companys/getSingleCompDoc",
  async (id) => {
    try {
      // console.log("id====>", id);
      const response = await BaseUrl.get(
        `my_Leads/companyDocs/${id}`,
        getAuthHeaders()
      );
      // console.log("company details===>", response.data)
      const responseData = await decryptFuc(response.data.data);
      // console.log("responseData===>", responseData);
      return responseData;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const updateCompDocdata = createAsyncThunk(
  "companys/updateCompDocdata",
  async (data) => {
    try {
      const response = await BaseUrl.patch(
        "my_Leads/companyDocs",
        data,
        getAuthHeaders()
      );
      // console.log("company docs===>", response.data)
      return response.data.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const resgiterApi = createAsyncThunk(
  "companys/resgiterApi",
  async (data) => {
    try {
      const response = await BaseUrl.post(
        "/my_Leads/auth/signup-customer",
        data
      );
      // console.log("company data===>", response.data);
      return response.data;
    } catch (error) {
      alert(`${error.response.data.message}`);
      throw error; // Ensure the error is propagated
    }
  }
);
export const deleteCompDocdata = createAsyncThunk(
  "companys/deleteCompDocdata",
  async (id) => {
    // console.log("getAuthHeaders()===>", getAuthHeaders())
    try {
      const response = await BaseUrl.patch(`my_Leads/companyDocs/company-docs`, { id }, getAuthHeaders());
      // console.log("company docs===>", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`);
      Swal.fire({
        icon: "error",
        title: "Document",
        text: `${error?.response?.data?.message}`,
        showConfirmButton: false,
        timer: 3000
      })
      throw error; // Ensure the error is propagated
    }
  }
);
export const companySlice = createSlice({
  name: "company",
  initialState: {
    CompanyData: [],
    compDocData: [],
    compDropData: [],
    singleCompanyData: {},
    singleCompDoc: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCompanydata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCompanydata.fulfilled, (state, action) => {
        state.loading = false;
        state.CompanyData = action.payload;
      })
      .addCase(getAllCompanydata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getCompanyDropdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanyDropdata.fulfilled, (state, action) => {
        state.loading = false;
        state.compDropData = action.payload;
      })
      .addCase(getCompanyDropdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getSingleCompanydata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleCompanydata.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCompanyData = action.payload;
      })
      .addCase(getSingleCompanydata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getCompDocdata.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompDocdata.fulfilled, (state, action) => {
        state.loading = false;
        state.compDocData = action.payload;
      })
      .addCase(getCompDocdata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
    builder
      .addCase(getSingleCompDoc.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSingleCompDoc.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCompDoc = action.payload;
      })
      .addCase(getSingleCompDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

// SELECTORS
export const getCompanysData = (state) => state.company.CompanyData;
export const getCompDocData = (state) => state.company.compDocData;
export const getCompDropData = (state) => state.company.compDropData;
export const getSingleCompanysData = (state) => state.company.singleCompanyData;
export const getSingleCompDocument = (state) => state.company.singleCompDoc;
export const companyError = (state) => state.company.loading;

// EXPORTS
export default companySlice.reducer;